<template>
    <q-btn
        color="secondary"
        icon="checklist"
        label="Bulk Update"
        dense
        outline
        class="q-ml-sm"
        @click="isOpen = !isOpen"
    >
        <q-menu
          v-model="isOpen"
          @hide="onBulkDialogMenuHide"
          anchor="bottom left"
          v-if="isOpen"
        >
          <div class="quotes-bulk-actions q-pa-md">
            <div class="q-pb-sm">
              <q-select
                dense
                style="min-width: 200px;width:100%"
                emit-value
                map-options
                v-model="data.assigneeId"
                label="Re-assign"
                label-color="white"
                bg-color="primary"
                filled
                :options="assignees"
                option-value="id"
                :option-label="(item) => `${item.firstName} ${item.lastName}`"
                class="q-pr-sm"
              />
            </div>
            <div class="row q-gutter-x-sm items-center q-pb-sm" v-if="context !== 'order'">
              <q-select
                label="Status"
                label-color="white"
                :options="parentStatusOptions"
                :loading="loadingParentStatus"
                option-label="name"
                option-value="id"
                dense
                clearable
                bg-color="primary"
                filled
                emit-value
                map-options
                v-model="data.parentStatusId"
                @input="parentStatusChange"
                style="width: 160px"
              />
              <q-select
                style="width: 150px"
                dense
                clearable
                label="Child Status"
                label-color="white"
                bg-color="primary"
                filled
                emit-value
                map-options
                :options="childStatusOptions"
                option-label="name"
                option-value="id"
                v-model="data.childStatusId"
                class="q-pr-sm"
              />
            </div>
            <q-btn color="secondary" label="Save" @click="bulkUpdate" :loading="loading"/>
            <q-btn
              v-if="isFollowupContext"
              color="negative"
              label="Complete FollowUps"
              @click="completeFollowUp"
              :loading="loading"
            />
          </div>
        </q-menu>
    </q-btn>
</template>

<script>
import graphql from '@client/graphql';

export default {
  name: 'AppQuotesBulkActions',
  props: {
    context: String,
    loading: Boolean,
    isFollowupContext: Boolean
  },
  apollo: {
    assignees: {
      query: graphql.queries.loadAssignees
    },
    parentStatuses: {
      query: graphql.queries.getParentStatus,
      variables() {
        return { type: this.context === 'quote' ? 'QUOTE' : 'ORDER' };
      },
      watchLoading(isLoading) {
        this.loadingParentStatus = isLoading;
      },
      result(result) {
        if (result.loading) return;

        this.parentStatusOptions = result.data.parentStatuses;
      }
    }
  },
  data() {
    return {
      data: {
        parentStatusId: null,
        childStatusId: null,
        assigneeId: null
      },
      selectedChildStatus: '',
      loadingParentStatus: false,
      parentStatusOptions: [],
      childStatusOptions: [],
      isBulkDialogMenuOpen: false,
      isOpen: false
    };
  },
  methods: {
    parentStatusChange(value) {
      this.data.childStatusId = '';
      const parentStatus = this.parentStatusOptions.find((s) => s.id === value);
      this.childStatusOptions = parentStatus ? parentStatus.children : [];
    },
    bulkUpdate() {
      this.$emit('save', this.data);
    },
    completeFollowUp() {
      this.$emit('completeFollowUp', this.data);
    },
    onBulkDialogMenuHide() {
      this.isBulkDialogMenuOpen = true;
    }
  }
};
</script>
<style scoped lang="scss">
.quotes-bulk-actions {
  .action-title {
    font-size: 10px;
  }
  ::v-deep {
    .q-select {
      width: 120px;
    }
    .q-field__marginal,
    .q-field__native {
      color: #fff;
    }
  }
}
</style>
